import type { AvailableInOtherGradesEndpointType } from "../server/api/AvailableInOtherGradesEndpoint";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import { getAPI } from "../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ApiClient } from "../../../../common-deprecated/api-clients/ApiClient";

export const availableInOtherGradesClient: ApiClient<
    AvailableInOtherGradesEndpointType,
    {
        commonSettings: CommonSettingsType;
        modelId: string;
        bodyTypeId: string;
        carId: string;
        colourId: string;
        upholsteryId: string;
        wheelId: string;
        configurationObjectType: "car" | "colour" | "upholstery" | "wheel";
        configurationObjectId: string;
    }
> = {
    method: "get",
    route: ({
        commonSettings,
        modelId,
        bodyTypeId,
        carId,
        colourId,
        upholsteryId,
        wheelId,
        configurationObjectType,
        configurationObjectId,
    }) =>
        `${getAPI(
            commonSettings,
            "availableInOtherGrades",
            `/${modelId}/${bodyTypeId}/${carId}/${colourId}/${upholsteryId}/${wheelId}/${configurationObjectType}/${configurationObjectId}`,
        )}`,
};

export default availableInOtherGradesClient;
